<template>
  <div class="app-wrapper">
    <sidebar class="sidebar-container" :class="{ collapsed: !sidebarOpened }" />
    <div class="main-container" :class="{ collapsed: !sidebarOpened }">
      <navbar />
      <app-main />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from './components/Sidebar.vue'
import Navbar from './components/Navbar.vue'
import AppMain from './components/AppMain.vue'

export default {
  name: 'Layout',
  components: { Sidebar, Navbar, AppMain },
  computed: { ...mapGetters(['sidebarOpened']) }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  display: flex;
  height: 100%;
  width: 100%;
}
.sidebar-container {
  width: 210px;
  height: 100%;
  background: #304156;
  transition: width 0.28s;
  overflow: hidden;
  &.collapsed { width: 64px; }
}
.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  margin-left: 0;
}
</style>
